import { render, staticRenderFns } from "./PropertyJourney.vue?vue&type=template&id=29bba59a&scoped=true&"
import script from "./PropertyJourney.vue?vue&type=script&lang=js&"
export * from "./PropertyJourney.vue?vue&type=script&lang=js&"
import style0 from "./PropertyJourney.vue?vue&type=style&index=0&id=29bba59a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bba59a",
  null
  
)

export default component.exports